import React, { Component } from 'react';

import FormField from "../ui/FormFields";
import { validate } from "../ui/misc";

import Button from '@material-ui/core/Button';

import { firebase } from '../../firebase';

import { Helmet } from "react-helmet";

class SignIn extends Component {

  state = {
    formError: false,
    formSuccess: "",
    formData: {
      email: {
        element: "input",
        value: "",
        config: {
          name: "email_input",
          type: "email",
          placeholder: "Введите майл"
        },
        validation: {
          required: true,
          email: true
        },
        valid: false,
        validationMessage: ""
      },
      password: {
        element: "input",
        value: "",
        config: {
          name: "password_input",
          type: "password",
          placeholder: "Введите пароль"
        },
        validation: {
          required: true
        },
        valid: false,
        validationMessage: ""
      },
    }
  };
  updateForm(element) {
    const newFormData = { ...this.state.formData };
    const newElement = { ...newFormData[element.id] };

    newElement.value = element.event.target.value;

    let validData = validate(newElement);

    newElement.valid = validData[0];
    newElement.validationMessage = validData[1];

    newFormData[element.id] = newElement;

    console.log(newFormData);

    this.setState({
      formError: false,
      formData: newFormData
    });
  }


  submitForm(event) {
    event.preventDefault();

    let dataToSubmit = {};
    let formIsValid = true;

    for (let key in this.state.formData) {
      dataToSubmit[key] = this.state.formData[key].value;
      formIsValid = this.state.formData[key].valid && formIsValid;
    }

    if (formIsValid) {
      firebase.auth()
        .signInWithEmailAndPassword(
          dataToSubmit.email,
          dataToSubmit.password
        )
        .then(() => {
          this.props.history.push('/products/Продукты');
        }).catch(error => {
          this.setState({
            formError: true
          })
        })
    } else {
      this.setState({
        formError: true
      });
    }
  }

  render() {
    return (
      <div id="login">
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="robots" content="noindex, nofollow" />
        <link rel="shortcut icon" type="image/png" href="/public/Icon.png" />
        <title>Планета Рыбака - Логин</title>
        <link rel="canonical" href="https://rybalka-md.com" />
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
        <meta
          name="description"
          content="Магазин рыболовных изделий в Молдове, Кишинёв, улица Alba-Iulia 198 ger.34/1, рынок 'Дельфин'. Тут вы найдёте удилища, кутушки, снасти, прикормки, наживки, приманки, подставки, подсаки, сумки, одежда, снаряжения и другое, всё для рыбалки."
        />
        <meta
          property="og:url"
          content="https://rybalka-md.com/login"
        />
      </Helmet>
        <div className="container">
          <div className="login_wrapper">
            <form onSubmit={(event) => this.submitForm(event)}>
              <h1 className="all_products_title">Зайти в админ</h1>

              <FormField
                id={"email"}
                formData={this.state.formData.email}
                change={element => this.updateForm(element)}
              />

              <FormField
                id={"password"}
                formData={this.state.formData.password}
                change={element => this.updateForm(element)}
              />

              {this.state.formError ? (
                <div className="error_label">
                  Неправильный логин и/или пароль
                </div>
              ) : null}

            <Button 
              variant="contained" 
              onClick={event => this.submitForm(event)}
              className="login_button"
            > 
              Зайти
            </Button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default SignIn;